import { message } from 'doraemon';
import {
  getUserTypeList,
  getExternalList,
  getInstitutionOperator,
  getJobLevel,
  changeExternalState,
  getExternalDetail,
  getExternalEditDetail,
  deleteExternal,
  saveExternal,
  matchingOperator,
  getExternalImportRes,
  tempDownload,
  saveExternalImportRes,
  checkExternal,
  getAccountDetail,
  saveAccount,
} from '../services/index';

export default {
  namespace: 'externalUser',
  state: {
    userTypeList: [
      {
        key: 3,
        value: '外部人员',
      },
      {
        key: 2,
        value: '司机',
      },
    ],
  },
  effects: {
    *getUserTypeList({ payload }, { call, put }) {
      const { result, success, message: msg } = yield call(getUserTypeList, payload);
      if (!success) return message.error(msg || '获取任务列表接口错误');
      yield put({
        type: 'update',
        payload: {
          userTypeList: result || [],
        },
      });
    },
    // 获取列表接口
    *getExternalList({ payload }, { call }) {
      return yield call(getExternalList, payload);
    },
    // 浙里报人员数据下拉
    *getInstitutionOperator({ payload }, { call }) {
      return yield call(getInstitutionOperator, payload);
    },
    // 获取职级下拉枚举
    *getJobLevel({ payload }, { call }) {
      return yield call(getJobLevel, payload);
    },
    // 修改用户状态（启用/停用）
    *changeExternalState({ payload }, { call }) {
      return yield call(changeExternalState, payload);
    },
    // 获取编辑时详情
    *getExternalDetail({ payload }, { call }) {
      return yield call(getExternalDetail, payload);
    },
    // 获取编辑时详情
    *getExternalEditDetail({ payload }, { call }) {
      return yield call(getExternalEditDetail, payload);
    },
    // 删除
    *deleteExternal({ payload }, { call }) {
      return yield call(deleteExternal, payload);
    },
    // 保存
    *saveExternal({ payload }, { call }) {
      return yield call(saveExternal, payload);
    },
    // 内部人员匹配
    *matchingOperator({ payload }, { call }) {
      return yield call(matchingOperator, payload);
    },
    // 获取解析结果
    *getExternalImportRes({ payload }, { call }) {
      return yield call(getExternalImportRes, payload);
    },
    // 下载模板
    *tempDownload({ payload }, { call }) {
      return yield call(tempDownload, payload);
    },
    // 导入解析结果
    *saveExternalImportRes({ payload }, { call }) {
      return yield call(saveExternalImportRes, payload);
    },
    // 验证身份证 + 手机号
    *checkExternal({ payload }, { call }) {
      return yield call(checkExternal, payload);
    },
    // 查询账户信息
    *getAccountDetail({ payload }, { call }) {
      return yield call(getAccountDetail, payload);
    },
    // 保存账户信息
    *saveAccount({ payload }, { call }) {
      return yield call(saveAccount, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
